import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { api } from "@/lib/api";

import Layout from "@/components/site/Layout";
import ProtectedRoute from "@/components/site/ProtectedRoute";

import OnePage from "@/pages/OnePage";
import Sponsors from "@/pages/Sponsors";
import NewsArticle from "@/pages/NewsArticle";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function useGoogleAnalytics() {
  useEffect(() => {
    api.get("/settings").then(({ data }) => {
      const id = data?.ga4_id;
      if (!id || document.getElementById("ga4-script")) return;
      const s = document.createElement("script");
      s.id = "ga4-script";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", id);
    }).catch(() => {});
  }, []);
}

function App() {
  useGoogleAnalytics();
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<OnePage />} />
                <Route path="/sponsors" element={<Sponsors />} />
                <Route path="/news/:id" element={<NewsArticle />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
